export default "__VITE_ASSET__BMCiWQNX__"